<template>
  <div class="badge" :class="customClasses">
    <span class="badge__color" v-if="color"></span>
    <span class="badge__color" v-if="colorHex" :style="{'background-color': colorHex}"></span>
    <div class="badge__text" v-if="showText">
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'elementBadge',
  props: {
    text: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false,
      default: ''
    },
    colorHex: {
      type: String,
      required: false,
      default: ''
    },
    showText: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    customClasses () {
      return [
        (this.color) ? `is-${this.color}` : ''
      ]
    }
  }
}
</script>

<style lang="scss">
  $badge-colors: (
    public-holidays: #ffe600,
    travels: #da0041
  ) !global;

  .badge{
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;

    // Color

    &__color{
      @include size(1.6rem);
      flex: 0 0 auto;
      margin-right: 1rem;
      border-radius: .4rem;
    }

    // Text

    &__text{
      flex: 0 1 auto;
    }

    // Colors

    @each $key, $value in $badge-colors{
      &.is-#{$key}{
        .badge__color{
          background-color: $value;
        }
      }
    }

    @each $key, $value in $event-colors{
      &.is-#{$key}{
        .badge__color{
          background-color: $value;
        }
      }
    }
  }
</style>
